__turbopack_context__.v({
  "paymentMethodImg": "Vwc5Jq_paymentMethodImg",
  "wrapper": "Vwc5Jq_wrapper",
});
